/* eslint-env browser, es6 */
import m from "mithril";

import * as api from "../api";
import { ApiError, Duel } from "../api";
import { Board, generateRandomBoard } from "../board";
import { getDefaultPersistentNickname, setPersistentNicknameForDuel } from "../persistent-nickname";
import { ButtonView } from "./button";
import { CopyPasteView } from "./copy-paste";
import { NicknameInputView } from "./input";

interface DuelDialogViewAttrs {
  hookOnFinish?: (duel: Duel) => void;
  hookOnError: (error: ApiError) => void;
  board?: Board;
  hideStartButton?: boolean;
}

export class DuelDialogView implements m.Component<DuelDialogViewAttrs> {
  private hookOnFinish?: (duel: Duel) => void;
  private hookOnError: (error: ApiError) => void;
  private board: Board;
  private hideStartButton: boolean;

  private nicknameInputValue: string;
  private nicknameInputIsValid: boolean;
  private duel: Duel | null;

  constructor(vnode: m.Vnode<DuelDialogViewAttrs>) {
    this.hookOnFinish = vnode.attrs.hookOnFinish;
    this.hookOnError = vnode.attrs.hookOnError;
    this.board = vnode.attrs.board ?? generateRandomBoard();
    this.hideStartButton = vnode.attrs.hideStartButton ?? false;
    this.nicknameInputValue = getDefaultPersistentNickname();
    this.nicknameInputIsValid = true;
    this.duel = null;
  }

  view(): m.Children {
    if (!this.duel) {
      return [
        m(NicknameInputView, {
          hookOnInput: (value: string, isValid: boolean) => {
            this.nicknameInputValue = value;
            this.nicknameInputIsValid = isValid;
          },
          initialValue: this.nicknameInputValue
        }),
        m(ButtonView, {
          message: "Get duel link",
          disabled: !this.nicknameInputValue || !this.nicknameInputIsValid,
          hookOnClick: () => this.getDuelLink(this.nicknameInputValue),
        }),
      ];
    } else {
      const duel = this.duel;
      return [
        !this.hideStartButton
          ? m(ButtonView, {
            message: "Start duel",
            hookOnClick: () => {
              if (this.hookOnFinish) {
                this.hookOnFinish(duel);
              }
            },
          })
          : null,
        m(CopyPasteView, { duelId: duel.duelId }),
      ];
    }
  }

  getDuelLink(nickname: string): void {
    api
      .createDuel(nickname, this.board.letters)
      .then((duel: Duel) => {
        this.duel = duel;
        setPersistentNicknameForDuel(duel.duelId, nickname);
      })
      .catch((error: ApiError) => {
        this.hookOnError(error);
      });
  }
}
